// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__22M5Q","header":"ReportDetails_header__2gKDh","title":"ReportDetails_title__2qxWs","left":"ReportDetails_left__1dphk"};